//Import resources
import Navbar from "react-bootstrap/Navbar"; //Using 'react-bootstrap' (collapsible) Navbar for this design
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";

const MyNavbar = () => {
  //RETURN this JSX to UI
  //Ternary Operator is used to show different Navbars based on 'auth.username' existing or not (i.e. a user being logged in)
  return (
    <div className="container d-flex justify-content-center">
      <Navbar bg="light" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Link to="/" className="nav-link">
              Home
            </Link>
            <Link to="/scan" className="nav-link">
              Scan & Translate
            </Link>
            <Link to="/my-words" className="nav-link">
              My Words
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
export default MyNavbar;
